import React from 'react';
import { Box } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

import { useToggleModal } from '@hooks';
import uploadInputStyles from 'components/common/media/UploadInput/uploadInput.style';
import { ModalV2 } from 'components/common/modals';
import { LogisticsDocumentForm } from './LogisticsDocumentForm';

export const LogisticsDocumentModal = ({ onSubmit, loading }) => {
  const { handleClose, handleOpen, isOpen } = useToggleModal(false);

  const handleSubmit = async (values) => {
    await onSubmit(values);
    handleClose();
  };

  return (
    <>
      <Box
        onClick={handleOpen}
        sx={{
          cursor: 'pointer',
          ...uploadInputStyles.uploadArea,
          ...uploadInputStyles?.uploadAreaWithBackGround?.(),
        }}
      >
        <>
          <InsertDriveFileIcon
            data-testid="InsertDriveFileIcon"
            sx={uploadInputStyles.icon}
          />
          <Box sx={uploadInputStyles.uploadAreaText}>
            Επίλεξε τα αρχεία που θες να ανεβάσεις
          </Box>
        </>
      </Box>
      <Box
        sx={{ cursor: 'pointer', ...uploadInputStyles.uploadAreaIcon }}
        onClick={handleOpen}
      />
      <ModalV2
        id="add-new-document-modal"
        title="Add Documents to Logistics Task"
        isOpen={isOpen}
        size="sm"
        maxWidth="sm"
        onClose={handleClose}
      >
        <LogisticsDocumentForm
          onSubmit={handleSubmit}
          onCancel={handleClose}
          isLoading={loading}
        />
      </ModalV2>
    </>
  );
};

export default LogisticsDocumentModal;
